var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.5,
    r: 19.5,
    fill: "#3B6B94"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_844_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1627 16.5572C27.961 11.7702 23.1063 8.86369 18.3193 10.0653C14.5783 11.0044 11.862 14.2377 11.5821 18.0845C8.92589 18.5225 7.12767 21.0309 7.56571 23.6871C7.95511 26.0486 10.0013 27.7779 12.3945 27.7684H16.4566V26.1436H12.3945C10.5998 26.1436 9.14489 24.6887 9.14489 22.894C9.14489 21.0993 10.5998 19.6443 12.3945 19.6443C12.8432 19.6443 13.2069 19.2806 13.2069 18.8319C13.2029 14.7938 16.4732 11.5169 20.5113 11.5129C24.0069 11.5094 27.016 13.9807 27.6922 17.4102C27.7248 17.5772 27.8089 17.7298 27.9328 17.8464C28.0567 17.963 28.2141 18.0378 28.3828 18.0601C30.6038 18.3764 32.1478 20.4333 31.8316 22.6543C31.5476 24.6486 29.8448 26.1336 27.8303 26.1436H24.5807V27.7684H27.8303C30.9711 27.759 33.5095 25.2051 33.5 22.0644C33.492 19.4499 31.7025 17.1777 29.1627 16.5572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9411 19.88L16.6914 23.1296L17.8369 24.2751L19.7055 22.4147V30.2057H21.3303V22.4147L23.1907 24.2751L24.3362 23.1296L21.0866 19.88C20.7697 19.565 20.2579 19.565 19.9411 19.88Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_844_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.23779651bae9c5a91aea4cbac0324dbb.svg";
export { ForwardRef as ReactComponent };